import { render, staticRenderFns } from "./magazineRecord.vue?vue&type=template&id=f9bc102c&scoped=true"
import script from "./magazineRecord.vue?vue&type=script&lang=js"
export * from "./magazineRecord.vue?vue&type=script&lang=js"
import style0 from "./magazineRecord.vue?vue&type=style&index=0&id=f9bc102c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bc102c",
  null
  
)

export default component.exports